/* eslint-disable import/no-mutable-exports */
/** 提示错误消息的 message 方法 */
export let messageErrorFn: ((message: string) => void) | undefined
/** 登录过期的处理方法 */
export let onLoginExpire: ((res?: any) => void) | undefined

type Config = {
  messageErrorFn: typeof messageErrorFn
  /** 登录过期的处理方法 */
  onLoginExpire: ((res?: any) => void) | undefined
}

export function defineConfig(config: Partial<Config>) {
  messageErrorFn = config.messageErrorFn
  onLoginExpire = config.onLoginExpire
}
